import { render, staticRenderFns } from "./generate-cnab.vue?vue&type=template&id=12d61a66&scoped=true"
import script from "./generate-cnab.vue?vue&type=script&lang=js"
export * from "./generate-cnab.vue?vue&type=script&lang=js"
import style0 from "./generate-cnab.vue?vue&type=style&index=0&id=12d61a66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d61a66",
  null
  
)

export default component.exports